import api from '../config/api';

const API_URL = process.env.REACT_APP_TRAVEL_URI;
export const getSteps = type => {
  return api
    .get(`${API_URL}Step/${type}`)
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });
};

export const getAllTasks = () => {
  return api
    .get(`${API_URL}Task/`)
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      const errorMsg = error.message;
      return errorMsg;
    });
};
